module.exports = __webpack_public_path__ + "img/protected-bag-icon-7.6d785622.svg";